import React from 'react'
import styled from 'styled-components'
import IconEdit from 'assets/img/icon/edit-2.png'

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 32px;
  border: 1px solid #4e4d62;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 20px 8px 12px;
  background: transparent;
  background-image: url(${IconEdit});
  background-repeat: no-repeat;
  background-position-x: calc(100% - 5px);
  background-position-y: 50%;

  input {
    border: none;
    background: transparent;
    font-size: 14px;
    width: 100%;
    color: var(--half_white);

    &::placeholder {
      color: #818181;
    }
  }

  input:active,
  input:focus {
    outline: none;
    box-shadow: none;
  }
`

const RenderInputOrder = ({
  input,
  type,
  className,
  placeholder,
  autoFocus = false,
  disabled,
  meta: { touched, error },
}) => (
  <Container
    style={{
      borderColor: `${touched && error ? '#FF0000' : '#4e4d62'}`,
    }}
  >
    <input
      {...input}
      type={type}
      placeholder={placeholder}
      autoComplete="off"
      autoFocus={autoFocus}
      disabled={disabled}
    />
  </Container>
)

export default RenderInputOrder
